import type { Transaction } from '@/modules/projects'
import { withShareLabel } from '../../reconciliation/helpers'
import { AddRow } from './AddRow'
import { LedgerTable } from './LedgerTable'

// One account's rows for a cycle, read straight off the rows themselves. No balances, no net and no
// verdict: an account without the reconciliation feature has none of that, and printing a figure we
// never read would be a guess dressed up as a fact.
export const AccountLedgerSection = ({
  last4,
  shareNumber,
  rows,
  onEditAmount,
  onRemove,
  onRestore,
  onAdd,
  onJump,
}: {
  last4: string
  shareNumber: string | null
  rows: Transaction[]
  onEditAmount: (row: Transaction, next: number) => void
  onRemove: (row: Transaction) => void
  onRestore: (row: Transaction) => void
  onAdd: (input: { date: string; description: string; amount: number }) => void
  onJump: (page: number | null, fileUrl: string) => void
}) => (
  <div className="rounded-lg border bg-white p-3">
    <span className="flex items-baseline gap-1.5">
      <span className="text-xs font-normal uppercase tracking-wide text-muted-foreground">
        Account
      </span>
      <span className="text-sm font-medium tabular-nums text-foreground">
        {withShareLabel(last4 ? `••••${last4}` : 'Unknown', shareNumber)}
      </span>
    </span>

    {/* A new row needs an account to file it under, and this group has none to inherit. */}
    <AddRow
      onAdd={onAdd}
      blockedReason={last4 ? undefined : 'These rows carry no account number'}
    />

    <LedgerTable
      rows={rows}
      onEditAmount={onEditAmount}
      onRemove={onRemove}
      onRestore={onRestore}
      onJump={onJump}
    />
  </div>
)
